
interface WindowOrientation extends Window {
    inLandscapeMode: boolean;
    inPortraitMode: boolean;
}
(<any>window).inLandscapeMode = (window.innerHeight > window.innerWidth);
(<any>window).inPortraitMode = (window.innerHeight < window.innerWidth);
